export const markSelectedProduct = (products, groupID) => {
    return products.map(product => {
        if(product.GroupID === groupID) {
            product.isSelected = true;
        } else {
            product.isSelected = false;
        }
        return product;
    });
};

export const emptyProductsIfNotIncludedTypeGroup = (data) => {
    let copiedData = JSON.parse(JSON.stringify(data));

    for (let i = 0; i < copiedData.length; i++) {
        if(!copiedData[i].IsIncludedTypeGroup) {
            copiedData[i].Products = [];
        }
    }
    return copiedData;
};
